import React from 'react'
import HeroSection from '../components/homepage/HeroSection'
import Journey from '../components/homepage/Journey'
import ToolKit from '../components/homepage/ToolKit'
import SkillBtn from '../components/homepage/SkillBtn'
import Featured from '../components/homepage/Featured'
import HomeContact from '../components/homepage/HomeContact'

function Home() {
  return (
    <>
      <HeroSection />
      <Journey/>
      <ToolKit/>
      <SkillBtn/>
      <Featured/>
      <HomeContact/>
    </> 
  )
}

export default Home